import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Helper } from '../utils/helper';
import { Observable } from 'rxjs';
// import { LogModal } from '../components/log-modal/log-modal';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  readonly baseUrl = `${environment.baseUrl}`;
  readonly rootUrl = `${environment.rootUrl}`;
  constructor(private http: HttpClient) { }

  post_podImg(data) {
    return this.http.post(`${this.baseUrl}/uploader/file`, data);
  }

  get_logActivities(filter): Observable<any[]> {
    let params = this.extractFilter(filter);
    return this.http.get<any[]>(`${this.baseUrl}/activitylog/list/forconsignmentdetails`, { params: params })
    .pipe(
      map((res:any)=>res.result.items)
    );
  }

  private extractFilter(filter): HttpParams {
    const { Sort,SortDirection ,ConsignmentId ,EventType ,Page , Query } = filter;
    let params = new HttpParams()
      .set("Query", Query)
      .set("Page", Page);
    if (Sort != null && SortDirection != null) {
      params = params.set("Sort", Sort).set("SortDirection", SortDirection);
    }
    if (!Helper.isEmpty(ConsignmentId)) {
      params = params.set("ConsignmentId", ConsignmentId);
    }
    if (!Helper.isEmpty(EventType)) {
      params = params.set("EventType", EventType);
    }
    return params;
  }

  downloadReports(link) {
    if (!link) {
      return;
    }
    return this.http.get(link, { responseType: 'blob' });
  }
}
